module.exports = __webpack_public_path__ + "static/img/ri-whatsapp-line.9912152a.svg";